import { WalletGuardWalletSortField } from '../types'

export const FILTER_CONFIG = {
  address: { type: 'string' as const },
  name: { type: 'string' as const },
  currency: { type: 'array' as const },
  type: { type: 'array' as const },
  status: { type: 'array' as const },
  page: { type: 'string' as const, default: '1', pagination: true },
  pageSize: { type: 'string' as const, default: '10', pagination: true },
  sortField: { type: 'string' as const, pagination: true },
  sortOrder: { type: 'string' as const, pagination: true },
}

export const WALLET_SORT_FIELDS: WalletGuardWalletSortField[] = [
  'address',
  'name',
  'currency',
  'balance',
  'type',
  'lastCheckedAt',
  'status',
]

export const WALLET_CURRENCIES = ['USDT', 'USDC', 'ETH', 'BTC']

export const WALLET_NETWORKS = ['ETH', 'TRX', 'BTC']

export const WALLET_TYPE_LABELS: Record<string, string> = {
  SENDER: 'Отправитель',
  TRANSIT: 'Транзитный',
  FINAL: 'Финальный',
  OWN: 'Свой',
}

export const WALLET_STATUS_LABELS: Record<string, string> = {
  CLEAN: 'Чистый',
  SUSPICIOUS: 'Подозрительный',
  DANGEROUS: 'Опасный',
  BLOCKED: 'Заблокированный',
  UNCHECKED: 'Не проверен',
}

export const WALLET_STATUS_COLORS: Record<string, string> = {
  CLEAN: 'success',
  SUSPICIOUS: 'warning',
  DANGEROUS: 'error',
  BLOCKED: 'default',
  UNCHECKED: 'processing',
}

export const formatWalletDate = (value: string | null) => {
  const date = value ? new Date(value) : null
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleString('ru-RU')
    : '—'
}
